module.exports = __webpack_public_path__ + "static/media/tekura6.3ed9a5a5.jpg";